import React from "react";
import Container from "components/Layout/Container";
import manual from '../../assets/img/Logo/farmer-manual.jpg'
import ManualBox from "components/Ui/ManualBox";
import Conseiller from '../../assets/img/Logo/conseiller.jpg'
import Prestataire from '../../assets/img/Logo/prestataire.jpg'

function UserManuals() {
  return (
    <div className="w-full min-h-[70vh]">
      <div className="w-full h-[35vh] bg-[#fccd5d] my-12 flex items-center justify-center text-[#484848] font-bold ">
        <p className="text-inherit transition duration-1000 relative text-6xl after:inline-block after:absolute after:ease-in-out after:bg-[#484848] after:h-6 after:w-1/4 after:left-0 after:right-0 after:m-auto after:-bottom-14 after:transition-all after:duration-1000 hover:after:w-full">
          {" "}
          Manuels d'utilisation
        </p>
      </div>
      <div className="w-full sm:max-w-screen-2xl h-1/2 sm:px-6 mx-auto flex flex-wrap justify-between">
        <ManualBox image={manual} userType="fermier" sizeDoc={7} />
        <ManualBox image={Conseiller} userType="Conseiller" sizeDoc={5} />
        <ManualBox image={Prestataire} userType="prestataire" sizeDoc={7} />
      </div>
    </div>
  );
}

export default UserManuals;
